<template lang="pug">
v-container(v-if="!isAuthenticated()" grid-list-xl text-xs-center)
  v-layout(row mt-5)
    v-flex(xs10 offset-xs1)
      img(src="../../resources/assets/logo.png" alt="Logo")
      h3(v-if="$route.hash" style="margin-bottom: 4px;") Logging In
      v-progress-circular(
        v-if="$route.hash"
        indeterminate
        color="primary"
        )
      h3(v-if="!$route.hash")
      span(v-if="!$route.hash" class="welcome-text-subtitle") {{ $t('login.subTitle') }}
  v-layout(v-if="!$route.hash" row)
    v-flex(xs10 offset-xs1)
      v-btn(
        class="login-btn"
        default
        :loading="loading"
        type="submit"
        @click.native="login"
        id="login-instruction-text"
      ).mt-2 Login
  v-layout(complispace-staff-login)
     <a v-on:click="complispaceStaffLogin"> CompliSpace Staff Login</a>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import Base from '@/components/views/Base';

export default {
    name: 'Login',

    extends: Base,

    data() {
        return {
            e1: false,
            alias: null,
            password: null,
            auth: null
        };
    },

    computed: {
        ...mapState({
            idpUri: state => state.session.idpUri
        }),

        ...mapGetters({
            authorizationUri: 'session/authorizationUri',
            authorizationUriComplispaceStaff: 'session/authorizationUriComplispaceStaff',
            isAuthenticated: 'session/isAuthenticated'
        })
    },

    watch: {
        idpUri(value) {
            if (value.length > 0) this.loading = false;
        }
    },

    created() {
        // Set $route values that are not preset during unit testing
        if (process.env.NODE_ENV === 'testing') {
            this.$route = {
                name: 'LoginView',
                path: '/login',
            };
        }

        if (!this.idpUri.length > 0 && !this.$route.hash) this.loading = true;

        // If returning back from the Idp with a new token
        this.setSession();
    },

    methods: {
        showPassword() {
            this.e1 = !this.e1;
        },

        async login() {
            try {
                // Redirect to the IdP login screen
                location.href = this.authorizationUri;
            } catch (err) {
                this.showErrorAlert(err.message);
            }
        },
        async complispaceStaffLogin() {
            try {
                // Redirect to the IdP login screen
                location.href = this.authorizationUriComplispaceStaff;
            } catch (err) {
                this.showErrorAlert(err.message);
            }
        },
        async setSession() {
            // Sanity check
            if (!this.$route.hash && this.isAuthenticated()) {
                this.$nextTick(() => {
                    this.$router.push('/');
                });
                return;
            }
            if (!this.$route.hash) return;

            // NOTE: The form submit button will stop all multiple form submits
            // if there is a form in the process of being submitted. But if the
            // user presses enter then we need to stop multiple form submissions
            // - hence the sanity check.
            if (this.loading) return;
            this.loading = true;

            try {
                // pass a callback that will be called by the vuex singletons
                // when the token is set to expire. Must open a global dialog
                await this.$store.dispatch('session/login', {
                    uri: window.location.href
                });
                this.$nextTick(() => {
                    const nextroute = localStorage.getItem('id_returnroute');
                    if (nextroute) {
                        localStorage.removeItem('id_returnroute');
                        this.$router.push(nextroute);
                    } else {
                        this.$router.push('/');
                    }
                });
            } catch (err) {
                this.$store.dispatch('session/logout');
                this.$router.push('/login');
                this.$nextTick(() => this.showErrorAlert(err.message));
            } finally {
                this.loading = false;
            }
        }
    }
};
</script>

<style scoped>
  p { line-height: 24px; }

  img {
    margin-top: -15px;
    margin-bottom: 50px;
    width: 400px;
  }
  .complispace-staff-login{
      color:#00aeef;
      position: absolute;
      margin-top: 12px!important;
      bottom: 12px;
      padding: 1rem;
      left: 46.1%;
      width: 100%;
      height: 50px;
      top:87%;
  }
  .login-btn{
      /*margin-bottom: 3rem;*/
      font-family: Roboto,sans-serif;
      background-color: #00aeef !important;
      color: #fff;
  }

  #login-instruction-text,.welcome-text-subtitle{
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/components/views/Login.vue